import React, { useState, useEffect } from "react";

import LoadingIcon from "../Icons/LoadingIcon";
import Heading from "../Heading";
import Tabs from "../Tabs/Tabs";
import { getParamFromUrl } from "../../modules/utilities";

const FAQs = ({title = ''}) => {
    const [loading, setLoading] = useState(true);
    const [tabs, setTabs] = useState({});
    const [loadedTab, setLoadedTab] = useState(null);

    useEffect(() => {
        let getTabFromUrl = getParamFromUrl('tab');
    
        if (getParamFromUrl) {
            setLoadedTab(getTabFromUrl);
        }

        fetchTabs();
    }, []);

    const fetchTabs = async () => {
        const formData = new FormData();
        formData.append('security', wp_ajax.security);

        await fetch(`${wp_ajax.ajax_url}?action=faq_tabs`, {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    console.log(response.data[0].message);
                } else {
                    setTabs(response.tabs);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.log('Error during fetch: ' + error);
            });
    }

    if (loading && !tabs.length)
        return (<LoadingIcon/>)

    return (
        <div>
            <Heading
                alignment={{
                    horizontal: 'center',
                    vertical: 'column-reverse',
                }}
                title={title}
            />
            <Tabs
                tabs={tabs}
                parentDataType="faq"
                onLoadedTab={loadedTab}
            />
        </div>
    );
}
export default FAQs;